import { User } from 'models/User';

const USER_KEY = 'mgh-user';
const TOKEN_KEY = 'mgh-token';
const REFRESH_TOKEN_KEY = 'mgh-refresh-token';
const UNIT_ID_KEY = 'mgh-unit-id';
const EDGE_LOCAL_IP_ADDRESS_KEY = 'mgh-edge-local-ip-address';
const USER_DETAILS_KEY = 'mgh-user-details';

export const localStorageService = {
  setUser(user: string) {
    localStorage.setItem(USER_KEY, user);
  },
  getUser(): string | null {
    return localStorage.getItem(USER_KEY);
  },
  clearUser() {
    localStorage.removeItem(USER_KEY);
  },

  setUserDetails(user: User) {
    localStorage.setItem(USER_DETAILS_KEY, JSON.stringify(user));
  },
  getUserDetails(): User | null {
    const item = localStorage.getItem(USER_DETAILS_KEY);
    if (item) return JSON.parse(item);
    return null;
  },
  clearUserDetails() {
    localStorage.removeItem(USER_DETAILS_KEY);
  },

  setTokens(accessToken: string, refreshToken: string) {
    localStorage.setItem(TOKEN_KEY, accessToken);
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  },
  setAccessToken(accessToken: string) {
    localStorage.setItem(TOKEN_KEY, accessToken);
  },
  getTokens(): { accessToken: string; refreshToken: string } {
    const accessToken = localStorage.getItem(TOKEN_KEY) || '';
    const refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY) || '';
    return { accessToken, refreshToken };
  },
  clearTokens() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  },

  setUnitId(unitId: string) {
    localStorage.setItem(UNIT_ID_KEY, unitId);
  },
  getUnitId(): string | null {
    return localStorage.getItem(UNIT_ID_KEY);
  },
  clearUnitId() {
    localStorage.removeItem(UNIT_ID_KEY);
  },

  setEdgeLocalIPAddress: (ipAddress: string) =>
    localStorage.setItem(EDGE_LOCAL_IP_ADDRESS_KEY, ipAddress),
  getEdgeLocalIPAddress: () => localStorage.getItem(EDGE_LOCAL_IP_ADDRESS_KEY),
  clearEdgeLocalIPAddress: () => localStorage.removeItem(EDGE_LOCAL_IP_ADDRESS_KEY),

  clearAll() {
    this.clearUser();
    this.clearTokens();
    this.clearUnitId();
    this.clearUserDetails();
  },
};
